import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientesContactosService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  dataSource(varArgs : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Contactos/DataSource", varArgs, Sessions.header());
  }

  store(objClienteContacto : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Contactos/Store", objClienteContacto, Sessions.headerFormData());
  }

  storeExpres(objClienteContacto : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Contactos/StoreExpres", objClienteContacto, Sessions.headerFormData());
  }

  update(objClienteContacto : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Contactos/Update", objClienteContacto, Sessions.headerFormData());
  }

  delete(objClienteContacto : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Contactos/Delete", objClienteContacto, Sessions.header());
  }

  listByIdCliente(objClienteContacto : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Contactos/ListByIdCliente", objClienteContacto, Sessions.header());
  }

}